module.exports = __webpack_public_path__ + "DINNextLTPro-Regular.woff2?c7d8971eea12f6c9a4db5533de266fd2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Regular.woff2
// module id = 1376
// module chunks = 0